var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTriangularMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4D9EA1",
    d: "M8.01 11.322l9.904-.012-2.879-5.048-2.068-3.621L14.477 0l6.79 11.762.132.23.387.676-.387.676-6.853 11.987-1.564-2.662 2.053-3.594 2.885-5.059-4.51-.006-6.942-.002.77-1.347.773-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4E4C",
    d: "M1.543 22.64l9.903-.012-2.879-5.049-2.099-3.57 1.543-2.687 6.53 11.309 12.783-.008 1.548 2.708-17.42.003-4.51-.006L0 25.326l.77-1.347.773-1.34"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTriangularMobile);
export default __webpack_public_path__ + "static/media/logo-triangular-mobile.acb9f823.svg";
export { ForwardRef as ReactComponent };